import { LegalShell } from "./LegalShell";

export function Privacy() {
  return (
    <LegalShell title="Politique de confidentialité">
      <p>Dernière mise à jour : <strong>9 mai 2026</strong></p>

      <h2>1. Données collectées</h2>
      <ul>
        <li><strong>Identité</strong> : prénom, date de naissance.</li>
        <li><strong>Contact</strong> : numéro de téléphone, email (optionnel).</li>
        <li><strong>Financier</strong> : transactions, soldes wallet, opérateur mobile money utilisé.</li>
        <li><strong>Usage</strong> : coupons soumis, résultats, points Gift.</li>
      </ul>

      <h2>2. Finalités</h2>
      <ul>
        <li>Fournir le service (authentification, transactions, pronostics).</li>
        <li>Calculer les gains, bonus de parrainage, scores Gift.</li>
        <li>Communiquer avec l'utilisateur (notifications, support).</li>
        <li>Respecter les obligations légales (anti-fraude, comptabilité).</li>
      </ul>

      <h2>3. Hébergement et stockage</h2>
      <p>Les données sont hébergées sur Supabase. Les paiements transitent par PayDunya. Aucune donnée bancaire n'est stockée par Super-Pari.</p>

      <h2>4. Durée de conservation</h2>
      <ul>
        <li>Compte actif : tant que l'utilisateur ne demande pas la suppression.</li>
        <li>Compte supprimé : les transactions sont conservées 5 ans pour obligations légales.</li>
      </ul>

      <h2>5. Vos droits</h2>
      <p>Tu disposes des droits suivants :</p>
      <ul>
        <li>Accès, rectification, suppression de tes données.</li>
        <li>Portabilité (export sur demande).</li>
        <li>Opposition au traitement marketing.</li>
      </ul>
      <p>Pour exercer ces droits : contacte-nous par email.</p>

      <h2>6. Cookies</h2>
      <p>Super-Pari utilise uniquement des cookies techniques nécessaires au fonctionnement (session d'authentification, préférences). Aucun cookie publicitaire.</p>

      <h2>7. Sécurité</h2>
      <ul>
        <li>Chiffrement en transit (HTTPS partout).</li>
        <li>RLS Postgres pour l'isolation des données utilisateur.</li>
        <li>Aucune clé de paiement côté navigateur.</li>
      </ul>

      <h2>8. Sous-traitants</h2>
      <ul>
        <li><strong>Supabase</strong> : hébergement, base de données.</li>
        <li><strong>PayDunya</strong> : traitement des paiements mobile money.</li>
        <li><strong>API-Football</strong> : données de matchs et résultats.</li>
        <li><strong>Sentry</strong> : monitoring d'erreurs (sans PII).</li>
      </ul>
    </LegalShell>
  );
}
